import { PageBuilder } from '../../widget-framework/PageBuilder';
import { ConfigPanel } from '../../widget-framework/ConfigPanel';
import { useTabLayout } from './useTabLayout';

export function VaultTab() {
  const {
    layout, context,
    configPanelInstanceId, configItem,
    handleLayoutChange, handleOpenConfig, handleApplyConfig, closeConfigPanel,
  } = useTabLayout('vault');

  if (!context) return <div className="tab-loading" aria-label="Loading Vault" />;

  return (
    <div className="tab-root tab-root--vault">
      <PageBuilder
        tab={{ id: 'vault', label: 'Vault', icon: '🗄️' }}
        layout={layout}
        surface="custom_object"
        context={context}
        onLayoutChange={handleLayoutChange}
        onOpenConfig={handleOpenConfig}
      />
      <ConfigPanel
        instanceId={configPanelInstanceId}
        widgetId={configItem?.widgetId ?? null}
        currentConfig={configItem?.config ?? {}}
        onApply={handleApplyConfig}
        onClose={closeConfigPanel}
      />
    </div>
  );
}
